import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ConditionalFormulaDataSetFieldIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ConditionalFormulaDataSetField",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.83 27.67c-.3 0-.6-.11-.82-.34l-3.84-3.84-3.84 3.84c-.46.46-1.19.46-1.65 0s-.46-1.19 0-1.65l3.84-3.84L18.68 18c-.46-.46-.46-1.19 0-1.65s1.19-.46 1.65 0l3.84 3.84 3.84-3.84c.46-.46 1.19-.46 1.65 0s.46 1.19 0 1.65l-3.84 3.84 3.84 3.84c.46.46.46 1.19 0 1.65-.23.23-.53.34-.82.34Zm-14-4.67H3.17C2.53 23 2 22.48 2 21.83s.52-1.17 1.17-1.17h11.67c.64 0 1.17.52 1.17 1.17S15.49 23 14.84 23Zm8.11-9.98c-.69 0-1.34-.3-1.78-.83l-2.55-3.02a1.16 1.16 0 0 1 .14-1.64 1.16 1.16 0 0 1 1.64.14l2.55 3.02 5-5.94a1.16 1.16 0 0 1 1.64-.14c.49.41.56 1.15.14 1.64l-5 5.94c-.44.53-1.09.83-1.78.83m-8.11-1.69H3.17c-.64 0-1.17-.52-1.17-1.17s.52-1.17 1.17-1.17h11.67c.64 0 1.17.52 1.17 1.17s-.52 1.17-1.17 1.17Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16 12H3c-.55 0-1-.45-1-1s.45-1 1-1h13c.55 0 1 .45 1 1s-.45 1-1 1M16 22H3c-.55 0-1-.45-1-1s.45-1 1-1h13c.55 0 1 .45 1 1s-.45 1-1 1M23.67 13.33c-.26 0-.51-.1-.71-.29l-2.67-2.67a.996.996 0 1 1 1.41-1.41l1.96 1.96 4.63-4.63A.996.996 0 1 1 29.7 7.7l-5.33 5.33c-.2.2-.45.29-.71.29ZM21 25c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l6-6a.996.996 0 1 1 1.41 1.41l-6 6c-.2.2-.45.29-.71.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27 25c-.26 0-.51-.1-.71-.29l-6-6a.996.996 0 1 1 1.41-1.41l6 6a.996.996 0 0 1-.71 1.7Z"
      })]
    })
  }));
};